import React from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import appStoreImg from "../assets/img/app-store.png";
import googlePlayImg from "../assets/img/google.store.png";
import { trackAppStoreClick, trackGooglePlayClick } from "../analytics/googleAnalytics";
import "./MoneyPages.css";

export default function CaloriesPhotoApp() {
  return (
    <>
      <Helmet>
        <title>App para Contar Calorías con Foto Gratis | Wayo - IA al Instante</title>
        <meta
          name="description"
          content="Haz una foto a tu plato y Wayo te da las calorías y macros en segundos. La app para contar calorías con foto más rápida para comida española y platos caseros. Gratis."
        />
        <meta
          name="keywords"
          content="app para contar calorias con foto, contar calorias con foto, app calorias foto, app comida por foto, escaner calorias, contar calorias gratis, app nutricion IA"
        />
        <meta name="robots" content="index, follow, max-image-preview:large" />
        <link rel="canonical" href="https://wayoai.app/app-para-contar-calorias-con-foto" />
        <script type="application/ld+json">{JSON.stringify({
          "@context": "https://schema.org",
          "@type": "MobileApplication",
          "name": "Wayo - Contar Calorías con Foto",
          "description": "Haz una foto a tu plato y conoce las calorías y macros al instante con IA.",
          "applicationCategory": "HealthApplication",
          "operatingSystem": "iOS, Android",
          "offers": { "@type": "Offer", "price": "0", "priceCurrency": "EUR" }
        })}</script>
      </Helmet>

      <main className="money-page">
        <Header />
        <div className="money-shell">
          <section className="money-hero">
            <div className="money-copy">
              <span className="money-badge">App para contar calorías con foto</span>
              <h1>Haz una foto. Entiende mejor tu comida.</h1>
              <p>
                Si estás cansado de buscar alimento por alimento, una app para contar calorías con foto
                tiene sentido. La clave no es solo la IA: es <strong>registrar más rápido y aguantar más tiempo</strong>.
              </p>

              <div className="money-highlights">
                <div className="money-highlight">
                  <span>📸</span>
                  <div>
                    <strong>Más rápida que el registro manual</strong>
                    <span>Ideal para no abandonar por pereza o saturación.</span>
                  </div>
                </div>
                <div className="money-highlight">
                  <span>🍽️</span>
                  <div>
                    <strong>Mejor para comida real</strong>
                    <span>Mucho más útil con platos caseros y mezclados que una base de datos clásica.</span>
                  </div>
                </div>
                <div className="money-highlight">
                  <span>🎯</span>
                  <div>
                    <strong>Buena para adherencia</strong>
                    <span>Menos pasos significa más probabilidad de mantener el hábito.</span>
                  </div>
                </div>
              </div>

              <div className="money-store-row">
                <a
                  className="money-store-badge"
                  href="https://apps.apple.com/app/id6756500478"
                  onClick={() => trackAppStoreClick("calories_photo_hero")}
                >
                  <img src={appStoreImg} alt="Descargar Wayo en App Store" />
                </a>
                <a
                  className="money-store-badge"
                  href="https://play.google.com/store/apps/details?id=com.facundosolis.wayo"
                  onClick={() => trackGooglePlayClick("calories_photo_hero")}
                >
                  <img src={googlePlayImg} alt="Descargar Wayo en Google Play" />
                </a>
              </div>
            </div>

            <div className="money-visual">
              <span className="money-score">Pensada para 2026</span>
              <div className="money-visual-card">
                <h3>Cuándo una app con foto marca diferencia</h3>
                <ul>
                  <li>Cuando comes platos caseros o fuera de casa</li>
                  <li>Cuando te agobia pesar ingredientes</li>
                  <li>Cuando abandonas porque registrar te da pereza</li>
                  <li>Cuando quieres rapidez, no una tarea extra</li>
                </ul>
              </div>

              <div className="money-mini-grid">
                <div className="money-mini-card">
                  <strong>2 seg</strong>
                  <span>Ese es el tipo de experiencia que buscas en vez de registrar a mano.</span>
                </div>
                <div className="money-mini-card">
                  <strong>+adh.</strong>
                  <span>Menos fricción suele traducirse en más constancia.</span>
                </div>
              </div>
            </div>
          </section>

          <div className="money-sections">
            <section className="money-section">
              <h2>Cómo funcionan las apps que calculan calorías con foto</h2>
              <p>
                Usan visión artificial para interpretar el plato y estimar calorías y macros. No son mágicas,
                pero pueden ser muchísimo más útiles que el conteo manual si lo que buscas es rapidez y una
                estimación razonable.
              </p>
            </section>

            <section className="money-section">
              <h2>Ventajas frente al conteo manual</h2>
              <ul>
                <li>Menos pasos para cada comida</li>
                <li>Más facilidad con platos caseros</li>
                <li>Mejor experiencia si comes fuera</li>
                <li>Más probabilidad de mantener el hábito</li>
              </ul>
            </section>

            <section className="money-cta">
              <h3>Lo importante no es solo detectar comida. Es que no te canse.</h3>
              <p>
                Una app con foto vale la pena cuando te ayuda a registrar sin convertir la nutrición en otra tarea pesada.
              </p>
              <div className="money-store-row">
                <a
                  className="money-store-badge"
                  href="https://apps.apple.com/app/id6756500478"
                  onClick={() => trackAppStoreClick("calories_photo_mid")}
                >
                  <img src={appStoreImg} alt="Descargar Wayo en App Store" />
                </a>
                <a
                  className="money-store-badge"
                  href="https://play.google.com/store/apps/details?id=com.facundosolis.wayo"
                  onClick={() => trackGooglePlayClick("calories_photo_mid")}
                >
                  <img src={googlePlayImg} alt="Descargar Wayo en Google Play" />
                </a>
              </div>
            </section>

            <section className="money-section">
              <h2>Qué opción recomendamos</h2>
              <table className="money-table">
                <thead>
                  <tr>
                    <th>Opción</th>
                    <th>Mejor para</th>
                    <th>Comentario</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Wayo</td>
                    <td>Comida real y rapidez</td>
                    <td>Muy bien enfocada para platos caseros, adherencia y menos fricción.</td>
                  </tr>
                  <tr>
                    <td>Apps clásicas</td>
                    <td>Registro manual</td>
                    <td>Siguen siendo útiles, pero requieren mucho más tiempo y paciencia.</td>
                  </tr>
                </tbody>
              </table>
            </section>

            <section className="money-section">
              <h2>Cuándo fallan estas apps</h2>
              <p>Fallan más con mala luz, salsas, cantidades ambiguas o platos muy complejos. Por eso es mejor pensar en ellas como una forma rápida de estimar, no como una báscula de laboratorio.</p>
            </section>

            <section className="money-section">
              <h2>Preguntas frecuentes</h2>
              <div className="money-faq-grid">
                <div className="money-faq-item">
                  <h3>¿Sirve para comida casera?</h3>
                  <p>Sí, y ahí es precisamente donde una app con foto puede aportar más frente al registro manual clásico.</p>
                </div>
                <div className="money-faq-item">
                  <h3>¿Es mejor que buscar alimentos a mano?</h3>
                  <p>Si tu prioridad es tardar menos y sostener el hábito, normalmente sí.</p>
                </div>
                <div className="money-faq-item">
                  <h3>¿Puedo usarla también para macros?</h3>
                  <p>Sí. Además de calorías, puedes orientarte con proteína, carbohidratos y grasas.</p>
                </div>
              </div>
              <div className="money-inline-links">
                <Link to="/blog/mejores-apps-contar-calorias-2026">Ver comparativa larga</Link>
                <Link to="/alternativa-myfitnesspal">Ver alternativa a MyFitnessPal</Link>
                <Link to="/blog/mejores-apps-contar-calorias-gratis-2026">Ver ranking de contadores</Link>
              </div>
            </section>
          </div>
        </div>
        <Footer />
      </main>
    </>
  );
}
